import api from "./api";

export function getVisaAppointmentPage(country_id) {
  return api.get(`/visaappointment/${country_id}`);
}

export function createVisaAppointmentPage(data) {
  return api.post("/visaappointment", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateVisaAppointmentPage(country_id, data) {
  return api.put(`/visaappointment/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
